import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { Customer } from "@acto/taskpane/core/domain";
import { mapClientToCustomer } from "./mapClientToCustomer";

const ClientsByCrmIdQuery = graphql(`
  query GetClientsByCrmId($crmId: String!) {
    clientsByCrmId(crmId: $crmId) {
      ...ClientForDetailsWithRecommendedObservation
    }
  }
`);

export function useCustomersByCrmId(crmId: string): DataAccessResult<Customer> {
  const [result] = useQuery({
    query: ClientsByCrmIdQuery,
    variables: { crmId },
    pause: !crmId,
    requestPolicy: "cache-first",
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = !data && isFetching;

  const customers = useMemo(() => {
    if (!data || !data.clientsByCrmId) {
      return undefined;
    }

    return data.clientsByCrmId.map(mapClientToCustomer);
  }, [data]);

  return {
    data: customers,
    isFetching,
    isPending,
    error,
  };
}
